module.exports = __webpack_public_path__ + "img/map.59b482bc.png";